import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';
import { Box, Toolbar, useMediaQuery } from '@mui/material';

import Drawer from './Drawer';
import Header from './Header';
import navigation from 'menu-items';
import Breadcrumbs from 'components/@extended/Breadcrumbs';

import { openDrawer } from 'store/slices/menu';
import { loadStores, loadSuppliers, loadBrands, loadProductClasses } from 'store/slices/dashboard';

import FilterDrawer from 'components/dashboard/FilterDrawer';

const DashboardLayout = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const matchDownLG = useMediaQuery(theme.breakpoints.down('xl'));
    const dispatch = useDispatch();

    const session = useSelector((state) => state.session);
    const dashboard = useSelector((state) => state.dashboard);

    const goToLogin = async () => {
        navigate('/login');
    };

    useEffect(() => {
        if (session.loggedIn === false) {
            goToLogin();
        }
    }, [session.loggedIn]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (session.loggedIn === true) {
            if (!dashboard.stores.data) dispatch(loadStores(session.credentials.token));
            if (!dashboard.suppliers.data) dispatch(loadSuppliers(session.credentials.token));
            if (!dashboard.brands.data) dispatch(loadBrands(session.credentials.token));
            if (!dashboard.productClasses.data) dispatch(loadProductClasses(session.credentials.token));
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const { drawerOpen } = useSelector((state) => state.menu);

    // drawer toggler
    const [open, setOpen] = useState(drawerOpen);
    const handleDrawerToggle = () => {
        setOpen(!open);
        dispatch(openDrawer({ drawerOpen: !open }));
    };

    // set media wise responsive drawer
    useEffect(() => {
        setOpen(!matchDownLG);
        dispatch(openDrawer({ drawerOpen: !matchDownLG }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchDownLG]);

    useEffect(() => {
        if (open !== drawerOpen) setOpen(drawerOpen);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [drawerOpen]);

    return (
        <Box sx={{ display: 'flex', width: '100%' }}>
            <FilterDrawer />
            <Header open={open} handleDrawerToggle={handleDrawerToggle} />
            <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />
            <Box component="main" sx={{ width: '100%', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
                <Toolbar />
                <Breadcrumbs navigation={navigation} divider={false} />
                <Outlet />
            </Box>
        </Box>
    );
};

export default DashboardLayout;
